import * as actionTypes from '../../constants/ActionTypes/SelectDevice';

const initialState = {
    deviceList: {},
    loading: false,
    error: null,
    success:false,
    unEnrolledDevicesList: {} // for supporting multiple device enrollments
  }

const SelectDevice = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.FETCH_DEVICE_LIST:
            return {
                ...state,
                loading: true
            }
        
        case actionTypes.FETCH_DEVICE_LIST_SUCCESS:
            return {
                ...state,
                deviceList: action.deviceList,
                loading: false,
                success:true
            }
        
        case actionTypes.FETCH_DEVICE_LIST_ERROR:
            return {
                ...state,
                loading: false,
                error: action.message
            }
        case actionTypes.RESET_DEVICE_LIST:
            return {
                initialState 
            }
        case actionTypes.FETCH_UPDATED_DEVICE_LIST:
            return {
                ...state,
                unEnrolledDevicesList: action.unEnrolledDevicesList,
                success: true,
                error: false,
                loading: false
            }
        default:
            return {...state}
    }
}

export default SelectDevice